import { httpGet } from './apiService';
import { Video } from '@models/video';
import { PagedResult } from '@models/pagination';
import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';

export class VideoPublicService extends TaggedSlugEntityPublicApiService<Video> {
    constructor() {
        super('/api/video');
    }

    public async getVideosByTagId(tagIds: number[], page = 1, maxRecordsPerPage = 9): Promise<PagedResult<Video>> {
        const ids = tagIds.map((tagId) => `tagIds=${tagId}`).join('&');

        const result = await httpGet(
            `${this.baseUrl}/paged/tag/?${ids}&page=${page}&maxRecordsPerPage=${maxRecordsPerPage}`
        );

        return result.json();
    }
}
